import * as React from 'react';

import { useArgs } from '@storybook/preview-api';
import { Meta } from '@storybook/react';

import { SmallButton } from '~shared/components/buttons';

import { EmbedAudioVideoPaywall } from './EmbedAudioVideoPaywall';

export default {
  title: 'Teacher/Activity/Paywall Dialog',
  component: EmbedAudioVideoPaywall,
  parameters: { actions: { argTypesRegex: '^on.*' } },
} as Meta;

export const EmbedAudioVideoPaywallModal = () => {
  const [{ open }, updateArgs] = useArgs();
  return (
    <>
      <SmallButton onClick={() => updateArgs({ open: !open })}>
        Open dialog
      </SmallButton>
      <EmbedAudioVideoPaywall
        onClose={() => updateArgs({ open: false })}
        open={open}
      />
    </>
  );
};
